import { I18n } from 'i18n-js';
import costEstimatorTranslations from './cost_estimator_translations.js';

const i18n = new I18n(costEstimatorTranslations);
i18n.defaultLocale = 'en';
i18n.locale = 'en';

globalThis.I18n = i18n;
